module.exports = "<a class=\"{{classes}}\" href=\"{{link.link}}\">{{link.text}}</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-library/link/link.component.html
// module id = ./src/app/ui-library/link/link.component.html
// module chunks = main